import { Gift, X, Mail } from "lucide-react";
import classes from "./WelcomeModal.module.css";

export default function WelcomeModal({
  isOpen,
  onClose,
  requiresVerification = false,
  email = "",
}) {
  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!requiresVerification) onClose();
  };

  return (
    <div className={classes.overlay} onClick={handleOverlayClick}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        <button className={classes.closeButton} onClick={onClose}>
          <X size={24} />
        </button>

        <div className={classes.iconWrapper}>
          <div
            className={classes.iconCircle}
            style={
              requiresVerification
                ? {
                    background: "linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)",
                    boxShadow: "0 8px 24px rgba(251, 191, 36, 0.3)",
                  }
                : undefined
            }
          >
            {requiresVerification ? (
              <Mail size={48} className={classes.icon} style={{ color: "#B45309" }} />
            ) : (
              <Gift size={48} className={classes.icon} />
            )}
          </div>
        </div>

        <h2 className={classes.title}>
          {requiresVerification ? "כמעט סיימנו – צריך לאמת את המייל" : "ברוכים הבאים!"}
        </h2>

        {requiresVerification ? (
          <>
            <p className={classes.message}>
              שלחנו לך מייל אימות
              {email ? (
                <>
                  {" "}לכתובת
                  <br />
                  <strong>{email}</strong>
                </>
              ) : (
                ""
              )}
              .
            </p>

            <div
              style={{
                background: "#F8FAFC",
                borderRadius: 16,
                padding: "16px 20px",
                margin: "0 0 20px",
                textAlign: "right",
                direction: "rtl",
                fontSize: 14,
                color: "#4A5D68",
                lineHeight: 1.7,
              }}
            >
              <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <span style={{ color: "#157A90", fontWeight: 700 }}>1.</span>
                <span>פתח את המייל ולחץ על קישור האימות</span>
              </div>
              <div style={{ display: "flex", gap: 10, alignItems: "flex-start", marginTop: 8 }}>
                <span style={{ color: "#157A90", fontWeight: 700 }}>2.</span>
                <span>חזור לאתר והתחבר עם המייל והסיסמה</span>
              </div>
              <div style={{ display: "flex", gap: 10, alignItems: "flex-start", marginTop: 8 }}>
                <span style={{ color: "#157A90", fontWeight: 700 }}>3.</span>
                <span>
                  קיבלת <strong style={{ color: "#157A90" }}>2 המרות חינם</strong> במתנה
                </span>
              </div>
            </div>

            <div
              style={{
                background: "#FEF3C7",
                borderRadius: 12,
                padding: "10px 14px",
                margin: "0 0 16px",
                fontSize: 13,
                color: "#78350F",
                direction: "rtl",
                textAlign: "right",
                lineHeight: 1.5,
              }}
            >
              לא רואה את המייל? בדוק בתיקיית <strong>הספאם / קידומי מכירות</strong>.
            </div>
          </>
        ) : (
          <>
            <p className={classes.message}>
              קיבלת <strong>2 המרות חינם</strong> במתנה!
            </p>
            <p className={classes.message}>
              אפשר להתחיל להמיר נסחי טאבו לאקסל עכשיו.
            </p>
          </>
        )}

        <button className={classes.startButton} onClick={onClose}>
          {requiresVerification ? "הבנתי, אאמת את המייל" : "מעולה, בואו נתחיל!"}
        </button>
      </div>
    </div>
  );
}
